export default __webpack_public_path__ + "static/media/supremelich.52bdfdd8.png";